import { OreStack, OreStepper } from '@edenredespana/oreneta'
import { useTranslation } from 'react-i18next'

import { AutoEnrollmentSteps } from '@/AutoEnrollment/domain'
import { AutoEnrollmentTranslation } from '@/AutoEnrollment/ui/autoEnrollmentTranslation'
import { useAutoEnrollment } from '@/AutoEnrollment/ui/context'
import {
  AutoEnrollmentStep0,
  AutoEnrollmentStep1,
  AutoEnrollmentStep2,
  AutoEnrollmentStep3,
  AutoEnrollmentStep4,
  AutoEnrollmentStep5,
} from '@/AutoEnrollment/ui/molecules'

const renderCurrentStep = (step: number): JSX.Element => {
  switch (step) {
    case AutoEnrollmentSteps.BILLING_DATA:
      return <AutoEnrollmentStep1 />
    case AutoEnrollmentSteps.STORE_DATA:
      return <AutoEnrollmentStep2 />
    case AutoEnrollmentSteps.DOCUMENTATION:
      return <AutoEnrollmentStep3 />
    case AutoEnrollmentSteps.SIGNATURE:
      return <AutoEnrollmentStep4 />
    case AutoEnrollmentSteps.CONFIRMATION:
      return <AutoEnrollmentStep5 />
    default:
      return <AutoEnrollmentStep0 />
  }
}

export const AutoEnrollmentStepper = (): JSX.Element => {
  const { t } = useTranslation()
  const { autoEnrollmentStep, autoEnrollmentModel } = useAutoEnrollment()

  return (
    <OreStack space="2xlarge" placeContent="stretch">
      <OreStepper
        activeStep={autoEnrollmentStep}
        steps={[
          t(AutoEnrollmentTranslation.stepper.step1),
          t(AutoEnrollmentTranslation.stepper.step2),
          t(AutoEnrollmentTranslation.stepper.step3),
          t(AutoEnrollmentTranslation.stepper.step4),
          t(AutoEnrollmentTranslation.stepper.step5),
        ]}
      />
      {autoEnrollmentModel ? renderCurrentStep(autoEnrollmentStep) : null}
    </OreStack>
  )
}
